/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */
// Angular
import { NgModule, NgZone, Component, ElementRef, Renderer, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
// Core
import { ControlComponent } from '../../core/component/control.component';
import { NgcErrorModule } from '../error/ngc-error.component';
// JQX Widget
import { jqxCheckBoxComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxcheckbox';

// Control Value Accessor
const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NgcCheckBoxComponent),
    multi: true
};

/**
 * Check Box
 */
@Component({
    selector: 'ngc-checkbox',
    template: `<jqxCheckBox *ngIf="visible" (onChange)="inputChange($event)"
                [animationShowDelay] = "animationShowDelay"
                [animationHideDelay] = "animationHideDelay"
                [boxSize] = "boxSize"
                [checked] = "checked"
                [disabled] = "disabled"
                [enableContainerClick] = "enableContainerClick"
                [groupName] = "groupName"
                [hasThreeStates] = "hasThreeStates"
                [locked] = "locked"
                [rtl] = "rtl"
                [theme] = "theme"
                [width] = "width"
                [height] = "height">
                <ng-content></ng-content>
                </jqxCheckBox>
                <ngc-error [value]="error"></ngc-error>
                `,
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class NgcCheckBoxComponent extends ControlComponent {
    @Input('animationShowDelay') animationShowDelay: any;
    @Input('animationHideDelay') animationHideDelay: any;
    @Input('boxSize') boxSize: any;
    @Input('checked') checked: any;
    @Input('enableContainerClick') enableContainerClick: any;
    @Input('groupName') groupName: any;
    @Input('hasThreeStates') hasThreeStates: any;
    @Input('locked') locked: any;
    @Input('rtl') rtl: any;
    @Input('theme') theme: any;
    @Input('width') width: any;
    @Input('height') height: any;
    @Input('auto-create') autoCreate: boolean = true;

    /**
     * Initialize
     */
    constructor(private ngZone: NgZone, private elementRef: ElementRef, private rendererRef: Renderer) {
        super(ngZone, elementRef, rendererRef);
    }

    /**
     * On Input Change
     * 
     * @param Event
     */
    inputChange($e) {
        this.value = $e.args.checked;
    }
}

/**
 * Check Box Module
 */
@NgModule({
    imports: [CommonModule, NgcErrorModule],
    exports: [NgcCheckBoxComponent],
    declarations: [NgcCheckBoxComponent, jqxCheckBoxComponent]
})
export class NgcCheckBoxModule {
}